import React, { useState } from 'react';
import { Modal, Button, List, Typography, Image, Space } from 'antd';
import { EyeOutlined, DownloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

const AttachmentViewModal = ({ row, parentKey, title, status }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const attachments = row[parentKey]?.info ?? [];

  const isImage = (fileName) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return imageExtensions.includes(fileExtension);
  };

  const handleDownload = (url, fileName) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Button
        onClick={showModal}
        disabled={!attachments.length || status === 1 || status === 2 || status === 3}
      >
        <EyeOutlined /> View Attachments
      </Button>
      <Modal
        title={`View Attachments - ${title}` || `Attachments`}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={800}
      >
        {attachments?.length ? (
          <List
            itemLayout="vertical"
            dataSource={attachments}
            renderItem={(item) => (
              <List.Item style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                <Space direction="vertical" size="large">
                  <List.Item.Meta
                    title={<Text>{item?.details || 'No details available'}</Text>}
                    description={
                      item?.attachment?.length
                        ? 'Attachment(s) uploaded'
                        : 'No attachments'
                    }
                  />
                  {item?.attachment?.map((attachment, index) => (
                    <div key={index} style={{ gap: 24, display:'flex', flexDirection:'column' }}>
                      {isImage(attachment?.url) ? (
                        <Image
                          width={400}
                          src={attachment?.url}
                          alt={attachment?.fileName}
                          style={{ marginBottom: '16px' }}
                        />
                      ) : (
                        <Text>{attachment?.fileName}</Text>
                      )}
                      <Button
                        icon={<DownloadOutlined />}
                        onClick={() =>
                          handleDownload(attachment.url, attachment.fileName)
                        }
                      >
                        Download
                      </Button>
                    </div>
                  ))}
                </Space>
              </List.Item>
            )}
          />
        ) : (
          <Text>No attachments to display</Text>
        )}
      </Modal>
    </>
  );
};

export default AttachmentViewModal;
